<template>
    <div v-if="planData.length" class="container_layout">
        <optionNotFoundFeedback
            :visible.sync="dialogVisible"
            title="請填寫您的廣告目的"
            emailTitle="找不到廣告目的"
        />
        <el-row class="guide_title fix_top">
            <el-col :span="16" :offset="4">本次的廣告活動目的為何？</el-col>
        </el-row>
        <el-row>
            <el-col :span="8" :offset="4" style="margin-top:32px;">
                <RadioGroup
                    :optionType="1"
                    :items="planData"
                    :activatedId="activatedId"
                    :showInfo="{txt:''}"
                    @change="onUpdateSelectedItem"
                ></RadioGroup>
            </el-col>
            <div class="scenario_fixed_right" style="">
                <template v-if="activatedId < 0">
                    <img style="max-width:360px;" src="./guide_step1_unselect.svg" alt="">
                </template>
                <template v-else>
                    <div class="scenario_meta">
                        情境示範
                    </div>
                    <div class="scenario_title">
                        {{currentOption.situation.title}}
                    </div>
                    <div class="scenario_story">
                        {{currentOption.situation.content}}
                    </div>
                </template>
            </div>
        </el-row>
        <el-row>
            <el-col :offset="6">
                  <span @click="dialogVisible = true" style="color:#4da1ff; cursor: pointer;">
                     找不到您的廣告目的?
                  </span>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import { GUIDE_MUTATIONS } from '../../../store/modules/guide'
import RadioGroup from '../components/RadioGroup'
import optionNotFoundFeedback from '../optionNotFoundFeedback'

export default {
  name: 'step1',
  props: ['path'],
  components: {
    RadioGroup,
    optionNotFoundFeedback
  },
  data () {
    return {
      dialogVisible: false
    }
  },
  computed: {
    ...mapState({
      activatedId: function (state) {
        return state.guide[this.path].purposeType.id
      },
      planData: function (state) {
        return state.guide.root.optionData.plan
      }
    }),
    currentOption: function () {
      let result = this.planData.filter((item) => {
        return item.id.toString() === this.activatedId.toString()
      })
      return result ? result[0] : { title: '', description: '' }
    }
  },
  methods: {
    onUpdateSelectedItem (data) {
      switch (this.path) {
        case 'purpose':
          this.$store.commit(GUIDE_MUTATIONS.PURPOSE.SET_PURPOSE_TYPE, data)
          this.$store.commit(GUIDE_MUTATIONS.PURPOSE.RESET_USER_SELECTED_OPTION)
          break
        default:
          break
      }
    }
  }
}
</script>

<style scoped>
.scenario_fixed_right{
    position:fixed;
    left:50%;
    margin-left:48px;
    margin-top:15vh;
    width:50%;
}
.scenario_fixed_right img{
    width:50%;
}
.scenario_meta{
    font-size:20px;
    margin-bottom:24px;
}
.scenario_meta:after{
    width: 80px;
    margin-top: -8px;
    height: 12px;
    background-color: #4da1ff;
    content: '';
    display: block;
    opacity: 0.5;
}
.scenario_title{
    font-size: 32px;
    font-weight: bold;
    margin-bottom:24px;
}
.scenario_story{
    font-size:18px;
    max-width:320px;
    line-height: 1.5;
}
</style>
